var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgLinkedinIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "16px",
    height: "16px",
    viewBox: "0 0 16 16",
    enableBackground: "new 0 0 16 16",
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M8.749,6.9c1.07-1.525,2.509-1.745,4.119-1.352c1.239,0.302,1.822,1.212,2.074,2.391 c0.136,0.638,0.16,1.284,0.161,1.932c0.003,1.643-0.003,3.286,0.006,4.929c0.001,0.219-0.044,0.296-0.28,0.291 c-0.798-0.016-1.597-0.016-2.395,0c-0.237,0.005-0.28-0.073-0.279-0.29c0.008-1.55,0.004-3.101,0.002-4.651 c0-0.371-0.029-0.739-0.124-1.1c-0.184-0.7-0.564-1.025-1.259-1.081c-0.795-0.063-1.387,0.242-1.66,0.867 C8.978,9.145,8.898,9.472,8.896,9.81c-0.012,1.643-0.024,3.285-0.018,4.928c0.001,0.279-0.056,0.379-0.354,0.371 c-0.786-0.021-1.573-0.013-2.36-0.003c-0.194,0.003-0.254-0.046-0.253-0.247c0.006-2.997,0.006-5.993,0.001-8.99 c0-0.187,0.038-0.259,0.243-0.256c0.775,0.012,1.55,0.012,2.325,0c0.208-0.003,0.288,0.047,0.274,0.268 C8.734,6.199,8.749,6.518,8.749,6.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M4.063,10.352c0,1.468-0.009,2.937,0.008,4.405c0.004,0.3-0.088,0.359-0.367,0.352 c-0.774-0.02-1.549-0.015-2.324-0.002c-0.213,0.004-0.269-0.052-0.268-0.267c0.008-2.983,0.008-5.966-0.001-8.949 c-0.001-0.236,0.073-0.282,0.29-0.279c0.786,0.012,1.573,0.014,2.358-0.001c0.238-0.005,0.311,0.051,0.309,0.3 C4.057,7.392,4.063,8.872,4.063,10.352z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M0.892,2.588c0-0.946,0.745-1.694,1.691-1.698c0.952-0.004,1.73,0.772,1.719,1.714 c-0.011,0.932-0.78,1.705-1.701,1.709C1.659,4.319,0.892,3.544,0.892,2.588z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLinkedinIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/linkedin-icon.1c90fbe9d6bbafa69b5614fe63c75682.svg";